import { Button, PlusIcon } from "melco-ui";
import { Key } from "react";
import { useTranslation } from "react-i18next";
import { useAddRemoveMachine } from "../../../hooks/reporting/useAddRemoveMachine";
import { ReportingMelcoMachineStatisticsModelsMachineListItem } from "melco-shared-logic";

export type BulkActionAddMachineProps = {
  allMachine: ReportingMelcoMachineStatisticsModelsMachineListItem[];
  selectedRowKeys: Key[];
  setSelectedRowKeys: (keys: Key[]) => void;
};

export const BulkActionAddMachine: React.FC<BulkActionAddMachineProps> = ({
  allMachine,
  selectedRowKeys,
  setSelectedRowKeys,
}) => {
  const { t } = useTranslation();
  const { addMachines } = useAddRemoveMachine();
  return (
    <>
      {selectedRowKeys.length > 0 && (
        <Button
          icon={<PlusIcon />}
          onClick={() => {
            const machinesToAdd = allMachine.filter(
              (c: ReportingMelcoMachineStatisticsModelsMachineListItem) => {
                return selectedRowKeys.includes(c.device_id!);
              }
            );

            addMachines(machinesToAdd);
            setSelectedRowKeys([]);
          }}
        >
          {t("reporting.machines.add_selected")}
        </Button>
      )}
    </>
  );
};
